import { render, staticRenderFns } from "./FormGroupBtnSubmit.vue?vue&type=template&id=0b353b55"
import script from "./FormGroupBtnSubmit.vue?vue&type=script&lang=js"
export * from "./FormGroupBtnSubmit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports